import React from 'react'
import Spinner from 'react-bootstrap/Spinner';


const TableLoader = () => {
    return (
        <div>
            <Spinner animation="border" variant="secondary" />
        </div>
    )
}

export default TableLoader
